import React from "react";
import "./App.css";
import BrtxRoutes from "./BrtxRoutes";
import { Container } from "react-bootstrap";
import _decrypt from "./componets/_decrypt";
import Tooltips from "./componets/_tooltips";
import BrtxToast from "./componets/BrtxToasts";
import NavBar from "./classes/layout/NavBar";
import _params from "./componets/_params";
import WebSocketLogin from "./componets/_webSocketLogin";
import Cookies from "./componets/_cookies";
import Maintenance from "./componets/_maintenance";
import Auth from "./componets/_auth";

class App extends React.Component {
  state = {
    ip: "",
    guid: "",
    user: {
      type: "annonymous",
    },
    noui: false,
    headerPage: {
      Icon: "",
      Title: "",
      SubTitle: "",
    },
    toast: {
      open: false,
      title: "",
      text: "",
      type: "",
    },
    loader: {
      open: false,
      placeholder: false,
    },
    alert: [],
  };

  setUser = (user) => {
    try {
      if (user.detail[0]._address != null)
        user.detail[0]._address = JSON.parse(
          this.props._decrypt(user.detail[0]._address)
        );
    } catch {}

    try {
      if (user.auth !== undefined) user.auth = JSON.parse(user.auth);
    } catch (err) {}

    this.setState({ user: user });
  };

  setAlert = (alert) => {
    let alerts = this.state.alert;
    alerts.push({ ...alert, datePush: new Date() });
    this.setState({ alert: alerts });
  };

  resetAlert = () => {
    this.setState({ alert: [] });
  };

  setLoading = (open = true) => {
    const loader = {
      open: open,
    };
    this.setState({ loader: loader });
  };

  setHeaderPage = (e) => {
    this.setState({
      headerPage: e,
    });
  };

  setToast = (text, title, type) => {
    const toast = {
      open: true,
      title: title,
      text: text,
      type: type,
    };
    this.setState({ toast: toast });
  };

  setLogOut = () => {
    localStorage.removeItem("u");
    this.setState({ user: { type: "annonymous" } });
    localStorage.setItem("logout", "Odhlášení proběhlo úspěšně");
  };

  async registerApp(type) {
    if (type === "user") {
      if (localStorage.getItem("u") !== null) {
        try {
          this.setUser(
            JSON.parse(this.props._decrypt(localStorage.getItem("u")))
          );
        } catch {
          localStorage.removeItem("u");
          window.location.reload();
        }
      }
    }

    if (type === "ip") {
      if (this.state.ip === "") {
        const _res = await this.props._api({
          ...this.state,
          ...this.props,
          setAlert: this.setAlert,
          resetAlert: this.resetAlert,
          setLoading: this.setLoading,
          successText: "",
          method: "get",
          endpoint: "/api/web/ip",
          param: "",
        });
        if (_res.status === 200) {
          let ip_data = JSON.parse(_decrypt(_res.data));
          localStorage.setItem("ip", ip_data.Ip);
          this.setState({ ip: ip_data.Ip });
        }
      }
    }

    if (type === "session") {
      if (this.state.guid === "") {
        if (sessionStorage.getItem("session") === null) {
          const _res = await this.props._api({
            ...this.state,
            ...this.props,
            successText: "",
            setAlert: this.setAlert,
            resetAlert: this.resetAlert,
            setLoading: this.setLoading,
            method: "get",
            endpoint: "/api/web/session",
            param: "",
          });

          this.setState({ loading: false });
          if (_res.status === 200) {
            let guiddata = JSON.parse(_decrypt(_res.data));
            sessionStorage.setItem("session", _res.data);
            this.setState({ guid: guiddata[0].guid });
          }
        } else {
          this.setState({ loading: false });
          try {
            let guiddata = JSON.parse(
              _decrypt(sessionStorage.getItem("session"))
            );
            this.setState({ guid: guiddata[0].guid });
          } catch {
            sessionStorage.removeItem("session");
            window.location.reload();
          }
        }
      }
    }

    return true;
  }

  async componentDidMount() {
    if (localStorage.getItem("webCamTypeSelect") === undefined)
      localStorage.setItem("webCamTypeSelect",JSON.stringify({ value: "4", label: "SD | Skeny dokumentace", prefix: "SD_" }))

      if (localStorage.getItem("webCamTypeSelect") === null)
      localStorage.setItem("webCamTypeSelect",JSON.stringify({ value: "4", label: "SD | Skeny dokumentace", prefix: "SD_" }))

    await this.registerApp("user");
    let ip = this.registerApp("ip");
    if (await ip) {
      await this.registerApp("session");
    }
  }

  noui = (e) => {
    this.setState({noui: e})
  }

  render() {
    /* Autologin pro domain IP */
    if (
      (this.state.ip.indexOf("192.168.") > -1 ||
        this.state.ip.indexOf("::1") > -1 ||
        this.state.ip === "127.0.0.1") &&
      !localStorage.getItem("u") &&
      window.location.href.indexOf("/OAuth2/") === -1
    ) {
      localStorage.setItem("lastPage", window.location.href);
      //this.props.setNavigate("/OAuth2/XrOg0oIYjx5Scmt6fhDjIqPsRll1qnM36NEgSIYp");
      window.location.replace(process.env.REACT_APP_OAUTH2);
    }

    if (this.state.guid !== "") {
      const { Bs, VARIANT } = this.props;
      return (
        <>
          {this.state.user.type !== "domain" && (
            <Auth {...this.state} {...this.props} setLogOut={this.setLogOut} />
          )}
          {/* <WebSocketLogin {...this.props} /> */}
          <Maintenance {...this.props} {...this.state} />
          
          <Tooltips />
          {this.state.toast.open && (
            <BrtxToast
              {...this.state.toast}
              onClose={() =>
                this.setState({
                  toast: { open: false, title: "", text: "", type: "" },
                })
              }
            />
          )}
          {!this.state.noui && (
            <NavBar {...this.props} {...this.state} setUser={this.setUser} />
          )}

          <div className="c-body d-flex justify-content-center ms-4 me-2">
            {this.state.user.type === "annonymous" && (
              <Container>
                {this.state.loader.open && (
                  <Bs alert variant={VARIANT.UNI} className="sticky-sm-top">
                    <Bs row>
                      <Bs col className="d-flex justify-content-between">
                        <Bs span>Probíhá načítání...</Bs>
                        <Bs
                          spinner
                          animation="border"
                          variant={VARIANT.SECONDARY}
                        />
                      </Bs>
                    </Bs>
                  </Bs>
                )}
                {this.state.alert.map((alrt) => (
                  <>
                    {alrt.text.length > 0 && (
                      <Bs
                        alert
                        variant={alrt.variant}
                        className="sticky-sm-top"
                        dismissible
                        onClose={this.resetAlert}
                      >
                        {alrt.text}
                      </Bs>
                    )}
                  </>
                ))}
                <BrtxRoutes
                  {...this.props}
                  {...this.state}
                  setHeaderPage={this.setHeaderPage}
                  navbarClick={() => {}}
                  setUser={this.setUser}
                  setLoading={this.setLoading}
                  setToast={this.setToast}
                  setAlert={this.setAlert}
                  resetAlert={this.resetAlert}
                  noui={this.noui}
                />
              </Container>
            )}
            {(this.state.user.type === "domain" ||
              this.state.user.type === "user") && (
              <Container
                className={this.props.screen.width > 767 ? "ps-300" : ""}
              >
                <BrtxRoutes
                  {...this.props}
                  {...this.state}
                  setHeaderPage={this.setHeaderPage}
                  navbarClick={() => {}}
                  setLoading={this.setLoading}
                  setToast={this.setToast}
                  setLogOut={this.setLogOut}
                  setUser={this.setUser}
                  setAlert={this.setAlert}
                  resetAlert={this.resetAlert}
                  noui={this.noui}
                />
              </Container>
            )}
          </div>
        </>
      );
    }
  }
}

export default _params(App);
